import { FC } from 'react';
import { useWatch } from 'react-hook-form';
import { VwapAnchorType, VwapMode, VwapSessionReset } from '@shared/types';
import { useTradingFormContext } from '../../trading-form-context';
import { TradingFormField } from '../../trading-form-field';
import { IndicatorIndexedPath } from '../indicator-config-form.utils';

type VwapFieldsProps = {
  path: IndicatorIndexedPath;
};

const sessionResetOptions = [
  VwapSessionReset.FOREX_NY_17,
  VwapSessionReset.UTC_DAY,
  VwapSessionReset.CUSTOM
];

export const VwapFields: FC<VwapFieldsProps> = ({ path }) => {
  const { control } = useTradingFormContext();
  const mode = useWatch({ control, name: `${path}.mode` });
  const sessionReset = useWatch({ control, name: `${path}.sessionReset` });
  const anchorType = useWatch({ control, name: `${path}.anchorType` });

  return (
    <>
      <TradingFormField
        type="select"
        name={`${path}.mode`}
        label="VWAP Mode"
        options={Object.values(VwapMode)}
        defaultValue={VwapMode.SESSION}
      />

      {mode === VwapMode.SESSION && (
        <>
          <TradingFormField
            type="select"
            name={`${path}.sessionReset`}
            label="Session Reset"
            options={sessionResetOptions}
            defaultValue={VwapSessionReset.FOREX_NY_17}
          />
          {sessionReset === VwapSessionReset.CUSTOM && (
            <TradingFormField
              type="numeric"
              name={`${path}.customSessionHourUtc`}
              label="Reset Hour UTC (0-23)"
            />
          )}
        </>
      )}

      {mode === VwapMode.ANCHORED && (
        <>
          <TradingFormField
            type="select"
            name={`${path}.anchorType`}
            label="Anchor Type"
            options={Object.values(VwapAnchorType)}
            defaultValue={VwapAnchorType.WEEK_OPEN}
          />
          {anchorType === VwapAnchorType.TIMESTAMP && (
            <TradingFormField
              type="date"
              name={`${path}.anchorTimestamp`}
              label="Anchor Date"
            />
          )}
        </>
      )}

      {mode === VwapMode.ROLLING && (
        <TradingFormField
          type="numeric"
          name={`${path}.period`}
          label="Rolling Period"
        />
      )}
    </>
  );
};
